var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "57px",
    height: "58px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(247, 94, 66)",
    d: "M40.47,29.233 L54.391,43.588 C57.603,46.803 57.603,52.13 54.391,55.229 C52.785,56.835 50.680,57.639 48.576,57.639 C46.471,57.639 44.366,56.835 42.760,55.229 L28.416,40.873 L14.71,55.229 C12.466,56.835 10.361,57.639 8.256,57.639 C6.151,57.639 4.46,56.835 2.441,55.229 C0.770,52.13 0.770,46.803 2.441,43.588 L16.785,29.233 L2.441,14.878 C0.770,11.663 0.770,6.452 2.441,3.237 C5.652,0.24 10.860,0.24 14.71,3.237 L28.416,17.593 L42.760,3.237 C45.972,0.24 51.179,0.24 54.391,3.237 C57.603,6.452 57.603,11.663 54.391,14.878 L40.47,29.233 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePlus);
export default __webpack_public_path__ + "static/media/orange-plus.3823d5abe4b26394fa9f3331dc562333.svg";
export { ForwardRef as ReactComponent };